import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import COLORS from '../../../../resources/style/Themes';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { useAppVersionProvider } from '../../../../context_providers/app_version_context/AppVersionProvider';
import { useTranslation } from 'react-i18next';

function UpdateRequiredModal({ show, onHide }) {
  const { t } = useTranslation();
  const { rolloutTimestamp } = useAppVersionProvider();

  const readableDate = rolloutTimestamp
    ? new Date(rolloutTimestamp).toLocaleTimeString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

  if (!rolloutTimestamp) return null;

  return (
    <Dialog
      open={show}
      onClose={onHide}
      fullWidth
      maxWidth="md"
      aria-labelledby="update-required-dialog"
    >
      <DialogTitle
        id="update-required-dialog"
        sx={{ backgroundColor: COLORS.SAFEGUARD_BLUE, color: COLORS.WHITE }}
      >
        {t(StringKeys.UPCOMING_UPDATE)}
      </DialogTitle>
      <DialogContent sx={{ mt: 3 }}>
        {t(
          StringKeys.WE_WILL_BE_UPDATING_THE_SAFEGUARD_EQUIPMENT_WEB_APPLICATION,
          { date: `${readableDate}` },
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            borderRadius: '10px',
            height: '42px',
            paddingBottom: 1,
            textAlign: 'center',
            justifyContent: 'center',
            border: 'none',
            backgroundColor: COLORS.SAFEGUARD_ORANGE,
            color: COLORS.WHITE,
            '&:hover': {
              backgroundColor: COLORS.HOVER_ORANGE,
            },
          }}
          onClick={onHide}
        >
          {t(StringKeys.GOT_IT)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateRequiredModal;
